import React from 'react';
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Helmet from 'react-helmet';

import '../assets/scss/main.scss';
require("typeface-exo");
require("typeface-roboto");

import ActionButtonContainer from '../containers/ActionButtonContainer';
import RemarkScreenContainer from '../containers/RemarkScreenContainer';

import MainFooter from '../components/MainFooter';
import MainHeader from '../components/MainHeader';

class DefaultLayout extends React.Component {

    checkLocation = () => {
        if((this.props.location.pathname !== '/en/about')||(this.props.location.pathname !== '/it/about')) return <MainFooter />
        else return (<div></div>)
    }

  render() {
    return (
      <div className="l-page-wrapper">
        <Helmet
          title="Rob's Structural Apps"
          meta={[{
            name: 'description',
            content: `My name is Roberto Gentile, I am a structural engineer.`
          }]}
        />

        <div className={`l-page-container ${this.props.remarkScreenisActive && 'is-blurred'}`}>
          <MainHeader pathname={this.props.location.pathname} />
          <main className="l-main">
            {this.props.children()}
        </main>
        {this.checkLocation()}
        </div>
        {
            (this.props.location.pathname === '/en/'
                || this.props.location.pathname === '/it/'
                || this.props.location.pathname === '/')
          &&
          <ActionButtonContainer
            locationPathName={this.props.location.pathname}
          />
        }
        <RemarkScreenContainer
          locationPathName={this.props.location.pathname}
        />
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return { remarkScreenisActive: state.remarkScreen.isActive };
}

const mapDispatchToProps = (dispatch) => {
  return { };
}

export default connect(mapStateToProps, mapDispatchToProps)(DefaultLayout);



// WEBPACK FOOTER //
// ./src/layouts/index.jsx